var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoaderVisible
    ? _c("div", { staticClass: "ui--content-wrapper display_b" }, [
        _c("div", { staticClass: "jumbotron index-img" }, [
          _c("div", { staticClass: "container inner" }, [
            _c("div", { staticClass: "row" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "col-7" }, [
                _c("img", {
                  staticClass: "main-object",
                  attrs: {
                    src: _vm.$CONTEXT + "/static/image/main/main_object1.png",
                    alt: "main object"
                  }
                })
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mcontents mcontents-1" }, [
          _c("div", { staticClass: "section-heading text-center" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("sdl.main.message.quickMenuMsg")) + ".")
            ])
          ]),
          _vm._v(" "),
          _vm._m(2)
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mcontents mcontents-2" }, [
          _c("div", { staticClass: "section-heading text-center" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.$t("sdl.main.message.findTopic")))])
          ]),
          _vm._v(" "),
          _vm._m(4),
          _vm._v(" "),
          _vm._m(5)
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mcontents mcontents-3" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-5 board-box" }, [
              _c("header", { staticClass: "group-header" }, [
                _c("h4", [_vm._v(_vm._s(_vm.$t("sdl.main.message.notice")))]),
                _vm._v(" "),
                _c(
                  "small",
                  [
                    _c(
                      "router-link",
                      {
                        attrs: { to: _vm.$CONTEXT + "/board/notice/user/list" }
                      },
                      [_vm._v(_vm._s(_vm.$t("sdl.main.message.viewMore")))]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "list-group list-border" },
                _vm._l(_vm.noticeList, function(row) {
                  return _c(
                    "li",
                    {
                      key: row.postId,
                      staticClass: "list-group-item",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.$router.push(
                            _vm.$context +
                              "/board/notice/user/view/" +
                              row.postId +
                              "/default"
                          )
                        }
                      }
                    },
                    [
                      _c("a", { attrs: { href: "#" } }, [
                        _vm._v(_vm._s(row.postTitle))
                      ]),
                      _vm._v(" "),
                      _c("small", { staticClass: "float-right" }, [
                        _vm._v(_vm._s(_vm._f("dateFormat")(row.regDate)))
                      ])
                    ]
                  )
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-5 board-box" }, [
              _c("header", { staticClass: "group-header" }, [
                _c("h4", [_vm._v("FAQ")]),
                _vm._v(" "),
                _c(
                  "small",
                  [
                    _c(
                      "router-link",
                      { attrs: { to: _vm.$CONTEXT + "/board/faq/user/list" } },
                      [_vm._v(_vm._s(_vm.$t("sdl.main.message.viewMore")))]
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "list-group list-border" },
                _vm._l(_vm.faqList, function(row) {
                  return _c(
                    "li",
                    {
                      key: row.postId,
                      staticClass: "list-group-item",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.$router.push(
                            _vm.$context +
                              "/board/faq/user/view/" +
                              row.postId +
                              "/default"
                          )
                        }
                      }
                    },
                    [
                      _c("a", { attrs: { href: "#" } }, [
                        _vm._v(_vm._s(row.postTitle))
                      ]),
                      _vm._v(" "),
                      _c("small", { staticClass: "float-right" }, [
                        _vm._v(_vm._s(_vm._f("dateFormat")(row.regDate)))
                      ])
                    ]
                  )
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-2 help-box" }, [
              _vm._m(6),
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _c("a", { attrs: { href: "javascript:" } }, [
                    _vm._v(_vm._s(_vm.$t("sdl.common.projectHelp")))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-tell" }, [_vm._v("1688-0987")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "itvoc" }, [
                  _c("a", { attrs: { href: "#;" } }, [
                    _c("img", {
                      attrs: {
                        src: _vm.$CONTEXT + "/static/image/main/logo_itvoc.png",
                        alt: "IT VOC Link"
                      }
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-5" }, [
      _c("h1", [_vm._v("ABC")]),
      _vm._v(" "),
      _c("strong", [_vm._v("ABC System Summary")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "The ABC provides a comprehensive programming, configuration model and reuseable common module for modern Java-based enterprise applications. "
        ),
        _c("a", { attrs: { href: "#;" } }, [_vm._v("Learn more")])
      ]),
      _vm._v(" "),
      _c("form", { staticClass: "form-inline search-group mt-5" }, [
        _c("input", {
          staticClass: "form-control",
          attrs: {
            type: "text",
            placeholder: "Input the keyword",
            "aria-label": "Input the keyword"
          }
        }),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "btn btn-search", attrs: { type: "submit" } },
          [_vm._v("Search")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", [
      _vm._v("Our Quick "),
      _c("span", { staticClass: "uppercase" }, [_vm._v("Menu")]),
      _vm._v("s")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row container" }, [
      _c("div", { staticClass: "col-3 text-center" }, [
        _c("a", { staticClass: "link-icon", attrs: { href: "#" } }, [
          _c("div", { staticClass: "circle-icon circle-2 circle-color-1" }, [
            _c("em", { staticClass: "icon-screen-desktop" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "link-text" }, [_vm._v("링크1")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-3 text-center" }, [
        _c("a", { staticClass: "link-icon", attrs: { href: "#" } }, [
          _c("div", { staticClass: "circle-icon circle-2 circle-color-1" }, [
            _c("em", { staticClass: "icon-screen-smartphone" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "link-text" }, [_vm._v("링크2")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-3 text-center" }, [
        _c("a", { staticClass: "link-icon", attrs: { href: "#" } }, [
          _c("div", { staticClass: "circle-icon circle-2 circle-color-1" }, [
            _c("em", { staticClass: "icon-book-open" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "link-text" }, [_vm._v("링크3")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-3 text-center" }, [
        _c("a", { staticClass: "link-icon", attrs: { href: "#" } }, [
          _c("div", { staticClass: "circle-icon circle-2 circle-color-1" }, [
            _c("em", { staticClass: "icon-picture" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "link-text" }, [_vm._v("링크4")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", [
      _vm._v("Popular Help "),
      _c("span", { staticClass: "uppercase" }, [_vm._v("Topic")]),
      _vm._v("s")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row container mt-5" }, [
      _c("div", { staticClass: "col-4" }, [
        _c("div", { staticClass: "topic-box" }, [
          _c("div", { staticClass: "circle-icon circle-2 circle-color-2" }, [
            _c("em", { staticClass: "icon-note" })
          ]),
          _vm._v(" "),
          _c("h5", [_vm._v("신규사용 신청")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "개발과제 추진정보, 공통기능 사용현황을 작성 Knox Portal 메모결재를 진행합니다."
            )
          ]),
          _vm._v(" "),
          _c("a", { attrs: { href: "#;" } }, [_vm._v("자세히보기")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4" }, [
        _c("div", { staticClass: "topic-box" }, [
          _c("div", { staticClass: "circle-icon circle-2 circle-color-2" }, [
            _c("em", { staticClass: "icon-bubbles" })
          ]),
          _vm._v(" "),
          _c("h5", [_vm._v("기술지원 요청")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "개발과제명, 문의사항을 작성 후, 담당자에게 메일로 요청합니다."
            )
          ]),
          _vm._v(" "),
          _c("a", { attrs: { href: "#;" } }, [_vm._v("자세히보기")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-4" }, [
        _c("div", { staticClass: "topic-box" }, [
          _c("div", { staticClass: "circle-icon circle-2 circle-color-2" }, [
            _c("em", { staticClass: "icon-people" })
          ]),
          _vm._v(" "),
          _c("h5", [_vm._v("개발교육 실행")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "교육은 매월 1회 실시되며, 참석자 명단을 작성하여 메일로 사전요청 합니다."
            )
          ]),
          _vm._v(" "),
          _c("a", { attrs: { href: "#;" } }, [_vm._v("자세히보기")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-5" }, [
      _c("p", { staticClass: "col-12 text-center mb-3" }, [
        _vm._v("찾고 있는 것이 없습니까? 더 많은 TOPIC을 만나보세요.")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "col-12 text-center" }, [
        _c("button", { staticClass: "btn btn-topic-more" }, [
          _vm._v("더 많은 TOPIC 찾아보기")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "group-header" }, [
      _c("h4", [_vm._v("Help")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13966bdc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13966bdc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/admin/main/MainIndexPage.vue
// module id = null
// module chunks = 